import React, {useContext, useEffect, useState} from 'react';
import './_RecipeModifiers.scss';
import classNames from 'classnames';
import useCallbackCreator from "../../../../../../hooks/useCallbackCreator";
import {TideApiContext} from "../../../../../../api/tideApiConfig";
import _ from 'lodash';
import {emptyRecipeForModifier} from "../../../../../../utils/modelUtils/orozco/orozcoRecipeUtils";
import RecipeEditor from "../../RecipeEditor";

const emptyArr = [];

const priceForModifier = modifier => {
    const price = _.find(
        modifier?.prices || [],
        {currency: 'MXN'}
    );

    if (!price || !price.amount)
        return 0;

    return Number(price.amount) / 100;
};

const RecipeModifiers = ({orozcoProduct, onChange}) => {

    const api = useContext(TideApiContext);

    const [openModifierId, setOpenModifierId] = useState();
    const [priceValue, setPriceValue] = useState('');
    const [savingPrice, setSavingPrice] = useState(false);

    const mods = (orozcoProduct?.orozcoProductModifiers || emptyArr)
        .filter(modifier => modifier.isActive !== false);

    const openModifier =
        !!openModifierId &&
        _.find(mods, m => m.id === openModifierId);

    const openModifierPrice =
        priceForModifier(openModifier);

    useEffect(() => {
        if (!openModifierId) {
            setPriceValue('');
            return;
        }

        setPriceValue(
            openModifierPrice > 0
                ? openModifierPrice.toFixed(2)
                : ''
        );
    }, [openModifierId, openModifierPrice]);

    const handleModifierClick = useCallbackCreator((id) => {
        const modifier = _.find(mods, m => m.id === id);

        if (!modifier)
            return;

        if (!modifier.orozcoRecipe)
            api.orozcoRecipes
                .create({
                    params: emptyRecipeForModifier(
                        orozcoProduct,
                        modifier
                    )
                })
                .then(onChange);

        setOpenModifierId(modifier.id);
    }, [mods]);

    const saveModifierPrice = () => {
        if (!openModifier || savingPrice)
            return;

        const parsed =
            priceValue === ''
                ? 0
                : Number(priceValue);

        if (
            Number.isNaN(parsed) ||
            parsed < 0
        )
            return;

        const amount = Math.round(parsed * 100);

        const prices =
            amount > 0
                ? [{
                    amount,
                    currency: 'MXN'
                }]
                : [];

        setSavingPrice(true);

        api.orozcoProductModifiers
            .setPrices({
                id: openModifier.id,
                params: {
                    name: openModifier.name,
                    prices
                }
            })
            .then(() => {
                setSavingPrice(false);

                if (onChange)
                    onChange();
            })
            .catch(() => {
                setSavingPrice(false);
            });
    };

    if (!mods.length)
        return null;

    return (
        <div className="RecipeModifiers">

            <h4 className='title'>
                Modificadores
            </h4>

            <ul className='modifiers-list'>
                {mods.map(modifier => {

                    const price =
                        priceForModifier(modifier);

                    return (
                        <li
                            className={classNames(
                                'modifier',
                                !modifier.orozcoRecipe && 'missing',
                                modifier.id === openModifier?.id && 'active'
                            )}
                            onClick={handleModifierClick(modifier.id)}
                            key={modifier.id}
                        >
                            <i
                                className={classNames(
                                    'fa',
                                    modifier.orozcoRecipe
                                        ? 'fa-clipboard'
                                        : 'fa-exclamation-triangle'
                                )}
                            />
                            {' '}

                            <span className='name'>
                                {modifier.name}
                            </span>

                            {price > 0 &&
                            <span className='sale-price'>
                                {' '}+ ${price.toFixed(2)}
                            </span>}
                        </li>
                    );
                })}
            </ul>

            {!!openModifier &&
            <div className='modifier-sale-price'>

                <label>
                    Precio de venta (MXN)
                </label>

                <div className='price-editor'>
                    <span className='currency-symbol'>
                        $
                    </span>

                    <input
                        type='number'
                        min='0'
                        step='0.01'
                        value={priceValue}
                        placeholder='0.00'
                        onChange={
                            event =>
                                setPriceValue(event.target.value)
                        }
                    />

                    <button
                        type='button'
                        className='btn btn-primary'
                        disabled={savingPrice}
                        onClick={saveModifierPrice}
                    >
                        {savingPrice
                            ? 'Guardando...'
                            : 'Guardar precio'}
                    </button>
                </div>

                <small>
                    Vacío o $0.00 = modificador sin cargo.
                    Este valor es precio de venta y no modifica
                    el costo calculado de la receta.
                </small>

            </div>}

            {!!openModifier?.orozcoRecipe &&
            <RecipeEditor
                recipeId={openModifier.orozcoRecipe.id}
                forceType='modifier'
            />}

        </div>
    );
};

export default RecipeModifiers;
